import React from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring, useTransform } from 'framer-motion';
import { Stars } from './Stars';
const DOLLY_PHOTO = 'https://cdn.magicpatterns.com/uploads/wdVvVwCjrtAreetnQ3qNmr/Dolly_Figueroa.png';
const SPRING = {
  stiffness: 140,
  damping: 18
};
export function Leadership() {
  const reduce = useReducedMotion();
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const pinkX = useSpring(useTransform(mx, [-0.5, 0.5], [0, 32]), SPRING);
  const pinkY = useSpring(useTransform(my, [-0.5, 0.5], [0, 32]), SPRING);
  const sunX = useSpring(useTransform(mx, [-0.5, 0.5], [8, 56]), SPRING);
  const sunY = useSpring(useTransform(my, [-0.5, 0.5], [8, 56]), SPRING);
  const photoRotate = useSpring(useTransform(mx, [-0.5, 0.5], [-3, 3]), SPRING);
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (reduce) return;
    const rect = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - rect.left) / rect.width - 0.5);
    my.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const reset = () => {
    mx.set(0);
    my.set(0);
  };
  return <section id="leadership" className="overflow-hidden bg-sand py-20 md:py-32" data-id="element-175" data-mp="kr51tx9g28mi">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 md:px-8 lg:grid-cols-12" data-id="element-176" data-mp="yi0ab8g16npk">
        <div className="relative mx-auto w-full max-w-md lg:col-span-5 lg:max-w-none" onMouseMove={handleMove} onMouseLeave={reset} data-id="element-177" data-mp="tp774p07nnfl">
          <motion.div className="absolute inset-0 rounded-[2rem] bg-sun" style={{
          x: sunX,
          y: sunY
        }} aria-hidden="true" data-id="element-178" data-mp="13gbjdgyi4u6q" />
          <motion.div className="absolute inset-0 rounded-[2rem] bg-flamingo" style={{
          x: pinkX,
          y: pinkY
        }} aria-hidden="true" data-id="element-179" data-mp="1hdqd2xvsfo4i" />
          <motion.img src={DOLLY_PHOTO} alt="Dolly Figueroa, CEO of Hondurans in LA" className="relative aspect-square w-full rounded-[2rem] object-cover" style={{
          rotate: photoRotate
        }} data-id="element-180" data-mp="3j7podj8wu5h7" />
        </div>

        <div className="lg:col-span-7 lg:pl-8" data-id="element-181" data-mp="1n3jf9gaa44gh">
          <p className="font-script text-4xl text-flamingo" data-id="element-182" data-mp="1n4b5scp0rbzw">Meet our CEO</p>
          <h2 className="mt-2 font-display text-7xl uppercase leading-[0.88] text-ink md:text-9xl" data-id="element-183" data-mp="1s2csd7lnltg4">
            Dolly
            <br data-id="element-184" data-mp="1w62fdsmok2z1" />
            <span className="text-catracho" data-id="element-185" data-mp="1w2ejwnxod6ho">Figueroa</span>
          </h2>
          <div className="mt-6 flex items-center gap-4" data-id="element-186" data-mp="213aufkcj7qw2">
            <Stars size={14} data-id="element-187" data-mp="262doyauvyeps" />
            <p className="text-sm font-bold uppercase tracking-wider text-ink/70" data-id="element-188" data-mp="261m4nw6qo3et">Chief Executive Officer</p>
          </div>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-ink/80 md:text-xl" data-id="element-189" data-mp="2avqdym3h8nj2">
            Dolly leads Hondurans In LA's work to celebrate Honduran culture, lift up Honduran-owned businesses, and
            build the partnerships that open doors for our community across Los Angeles.
          </p>
        </div>
      </div>
    </section>;
}